module.exports = __webpack_public_path__ + "img/c2.9fc280a0.jpg";